module.exports = {"page":{"CONTACTREQUEST":{"INFORMATION_MESSAGE_SAV_REDIRECTION":"Pour toutes demandes concernant vos bons d'achats sites marchands, merci de nous contacter via notre chat, depuis notre site <a href=\"{0}\" target=\"_blank\">{0}</a> en étant connecté à votre compte."}},"feature":{"aide":{"HOW_IT_WORKS":{"EBON":{"STEP2_CASHBACK_DISCOUNT":"<strong><span>{0} me {1}</span> sous 24h </strong> une partie de mon achat dans ma cagnotte."}}}}}


//////////////////
// WEBPACK FOOTER
// ./src/services/i18n/json/117.json
// module id = 1057
// module chunks = 0